import React, { useCallback } from 'react';
import cx from './index.module.scss';

interface Props {
  activeIndex?: number;
  onChange?: (activeIndex: number) => void;
}

const PAIN_LEVEL_LIST = [
  {
    desc: '察觉不到',
    backgroundColor: 'linear-gradient(180deg, #99FFD4 6.76%, #21DA8C 100%)',
  },
  {
    desc: '刚刚注意到',
    backgroundColor: 'linear-gradient(180deg, #9FFFFF 0%, #18D9D9 100%)',
  },
  {
    desc: '轻度疼痛',
    backgroundColor: 'linear-gradient(180deg, #6FBAFF 0%, #1382E8 100%)',
  },
  {
    desc: '中度疼痛',
    backgroundColor: 'linear-gradient(180deg, #FFE897 0%, #EEC329 96.93%)',
  },
  {
    desc: '重度疼痛',
    backgroundColor: 'linear-gradient(180deg, #FFBE99 0%, #E56116 98.4%)',
  },
  {
    desc: '剧烈疼痛',
    backgroundColor: 'linear-gradient(180deg, #FE8B71 0%, #B81F1F 98.46%)',
  },
];

const PainLevelRadio: React.FC<Props> = ({ activeIndex = -1, onChange }) => {
  const setIndex = useCallback(index => () => onChange?.(index), [onChange]);

  return (
    <div className={cx('pain-level-radio')}>
      {PAIN_LEVEL_LIST?.map((item, index) => (
        <div
          className={cx('radio-item', { active: activeIndex === index })}
          key={item.desc}
          onClick={setIndex(index)}
          style={{ background: item.backgroundColor }}
        >
          {item.desc}
        </div>
      ))}
    </div>
  );
};

export default PainLevelRadio;
